export default {
  "GETDictDictionaryAll": {
    "uri": "/dict/dictionaryAll",
    "pageId": "12926",
    "page_uri": "GET /dict/dictionaryAll",
    "title": "获取字典接口",
    "type": "GET"
  },
  "GETGetFileUploadUrl": {
    "uri": "/getFileUploadUrl",
    "pageId": "13611",
    "page_uri": "GET /getFileUploadUrl",
    "title": "获取OSS上传的路径",
    "type": "GET"
  },
  "POSTAccLogIn": {
    "uri": "/acc/logIn",
    "pageId": "12806",
    "page_uri": "POST /acc/logIn",
    "title": "登录",
    "type": "POST"
  },
  "POSTAccLogOut": {
    "uri": "/acc/logOut",
    "pageId": "12807",
    "page_uri": "POST /acc/logOut",
    "title": "退出登录",
    "type": "POST"
  },
  "GETAccLoginAuthority": {
    "uri": "/acc/loginAuthority",
    "pageId": "12808",
    "page_uri": "GET /acc/loginAuthority",
    "title": "获取用户权限",
    "type": "GET"
  },
  "GETGetMqttConfig": {
    "uri": "/getMqttConfig",
    "pageId": "13517",
    "page_uri": "GET /getMqttConfig",
    "title": "获取MQTT配置",
    "type": "GET"
  },
  "POSTAccUpdatePwd": {
    "uri": "/acc/updatePwd",
    "pageId": "13624",
    "page_uri": "POST /acc/updatePwd",
    "title": "修改密码",
    "type": "POST"
  },
  "GETGetVerifiCode": {
    "uri": "/getVerifiCode",
    "pageId": "13625",
    "page_uri": "GET /getVerifiCode",
    "title": "获取短信验证码",
    "type": "GET"
  },
  "GETCompanyGetPlanInfo": {
    "uri": "/company/getPlanInfo",
    "pageId": "15006",
    "page_uri": "GET /company/getPlanInfo",
    "title": "查询指定企业套餐信息",
    "type": "GET"
  },
  "GETDeviceStatistics": {
    "uri": "/device/statistics",
    "pageId": "12814",
    "page_uri": "GET /device/statistics",
    "title": "获取设备情况",
    "type": "GET"
  },
  "GETParamKv": {
    "uri": "/param/kv",
    "pageId": "13756",
    "page_uri": "GET /param/kv",
    "title": "获取套餐数据",
    "type": "GET"
  },
  "GETCompany": {
    "uri": "/company",
    "pageId": "12809",
    "page_uri": "GET /company",
    "title": "获取企业认证信息",
    "type": "GET"
  },
  "POSTCertificationIdentification": {
    "uri": "/certification/identification",
    "pageId": "12810",
    "page_uri": "POST /certification/identification",
    "title": "进行实名认证",
    "type": "POST"
  },
  "POSTDevice": {
    "uri": "/device",
    "pageId": "12818",
    "page_uri": "POST /device",
    "title": "绑定设备",
    "type": "POST"
  },
  "GETDevice": {
    "uri": "/device",
    "pageId": "12820",
    "page_uri": "GET /device",
    "title": "获取设备列表",
    "type": "GET"
  },
  "PUTDevice": {
    "uri": "/device",
    "pageId": "12822",
    "page_uri": "PUT /device",
    "title": "修改设备信息",
    "type": "PUT"
  },
  "DELETEDevice": {
    "uri": "/device",
    "pageId": "12823",
    "page_uri": "DELETE /device",
    "title": "解绑设备",
    "type": "DELETE"
  },
  "getDeviceDetail": {
    "uri": "/device/detail",
    "pageId": "12862",
    "page_uri": "get /device/detail",
    "title": "根据SN获取设备详情",
    "type": "get"
  },
  "POSTAsyTaskImport": {
    "uri": "/asyTask/import",
    "pageId": "13516",
    "page_uri": "POST /asyTask/import",
    "title": "导入设备批量绑定",
    "type": "POST"
  },
  "POSTDeviceNoBindDevices": {
    "uri": "/device/noBindDevices",
    "pageId": "13518",
    "page_uri": "POST /device/noBindDevices",
    "title": "批量解绑设备",
    "type": "POST"
  },
  "POSTDeviceEditDevices": {
    "uri": "/device/editDevices",
    "pageId": "13519",
    "page_uri": "POST /device/editDevices",
    "title": "批量修改设备",
    "type": "POST"
  },
  "POSTDeviceChangeDevicesGroup": {
    "uri": "/device/changeDevicesGroup",
    "pageId": "13520",
    "page_uri": "POST /device/changeDevicesGroup",
    "title": "批量设备换组",
    "type": "POST"
  },
  "GETDeviceGetDeviceUrl": {
    "uri": "/device/getDeviceUrl",
    "pageId": "13521",
    "page_uri": "GET /device/getDeviceUrl",
    "title": "获取xml地址",
    "type": "GET"
  },
  "GETDeviceVerifyXmlUrl": {
    "uri": "/device/verifyXmlUrl",
    "pageId": "13669",
    "page_uri": "GET /device/verifyXmlUrl",
    "title": "校验xml地址有效",
    "type": "GET"
  },
  "GETDeviceCheckDeviceNew": {
    "uri": "/device/checkDeviceNew",
    "pageId": "15008",
    "page_uri": "GET /device/checkDeviceNew",
    "title": "获取设备类型",
    "type": "GET"
  },
  "POSTDeviceIniConfig": {
    "uri": "/device/iniConfig",
    "pageId": "15163",
    "page_uri": "POST /device/iniConfig",
    "title": "批量配置INI-已废弃",
    "type": "POST"
  },
  "GETDeviceTaskList": {
    "uri": "/device/taskList",
    "pageId": "15164",
    "page_uri": "GET /device/taskList",
    "title": "获取任务列表",
    "type": "GET"
  },
  "POSTDeviceDownloadTime": {
    "uri": "/device/downloadTime",
    "pageId": "15774",
    "page_uri": "POST /device/downloadTime",
    "title": "修改设备时间",
    "type": "POST"
  },
  "PUTDeviceFourGStatus": {
    "uri": "/device/fourGStatus",
    "pageId": "15986",
    "page_uri": "PUT /device/fourGStatus",
    "title": "修改设备4G开通状态信息",
    "type": "PUT"
  },
  "PUTDeviceAlgorithmModel": {
    "uri": "/device/algorithmModel",
    "pageId": "15987",
    "page_uri": "PUT /device/algorithmModel",
    "title": "修改设备算法模型",
    "type": "PUT"
  },
  "GETDeviceFourGDevice": {
    "uri": "/device/fourGDevice",
    "pageId": "15988",
    "page_uri": "GET /device/fourGDevice",
    "title": "4G 设备列表",
    "type": "GET"
  },
  "GETDeviceAlgorithmModelDevice": {
    "uri": "/device/algorithmModelDevice",
    "pageId": "15989",
    "page_uri": "GET /device/algorithmModelDevice",
    "title": "支持大模型算法设备列表",
    "type": "GET"
  },
  "PUTDeviceBatchAlgorithmModel": {
    "uri": "/device/batchAlgorithmModel",
    "pageId": "15998",
    "page_uri": "PUT /device/batchAlgorithmModel",
    "title": "批量修改设备算法模型",
    "type": "PUT"
  },
  "POSTDeviceDownloadOss": {
    "uri": "/device/downloadOss",
    "pageId": "15999",
    "page_uri": "POST /device/downloadOss",
    "title": "下发设备OSS信息",
    "type": "POST"
  },
  "POSTDeviceImportWhitelist": {
    "uri": "/device/import/whitelist",
    "pageId": "16005",
    "page_uri": "POST /device/import/whitelist",
    "title": "批量下发白名单",
    "type": "POST"
  },
  "GETDeviceType": {
    "uri": "/device/type",
    "pageId": "16010",
    "page_uri": "GET /device/type",
    "title": "设备类型展示菜单",
    "type": "GET"
  },
  "PUTDeviceGroup": {
    "uri": "/device/group",
    "pageId": "12815",
    "page_uri": "PUT /device/group",
    "title": "修改分组信息",
    "type": "PUT"
  },
  "GETDeviceGroup": {
    "uri": "/device/group",
    "pageId": "12816",
    "page_uri": "GET /device/group",
    "title": "获取分组",
    "type": "GET"
  },
  "DELETEDeviceGroup": {
    "uri": "/device/group",
    "pageId": "12817",
    "page_uri": "DELETE /device/group",
    "title": "删除分组",
    "type": "DELETE"
  },
  "POSTDeviceGroup": {
    "uri": "/device/group",
    "pageId": "12821",
    "page_uri": "POST /device/group",
    "title": "新增分组",
    "type": "POST"
  },
  "GETGlobalQDevTreeBySn": {
    "uri": "/global/qDevTreeBySn",
    "pageId": "15007",
    "page_uri": "GET /global/qDevTreeBySn",
    "title": "查询设备详情",
    "type": "GET"
  },
  "GETGlobalQDevStatusBySn": {
    "uri": "/global/qDevStatusBySn",
    "pageId": "15997",
    "page_uri": "GET /global/qDevStatusBySn",
    "title": "更新设备状态",
    "type": "GET"
  },
  "POSTDeviceUpgradeTaskCancel": {
    "uri": "/device/upgradeTaskCancel",
    "pageId": "15101",
    "page_uri": "POST /device/upgradeTaskCancel",
    "title": "取消升级任务",
    "type": "POST"
  },
  "POSTDeviceBatchUpgrade": {
    "uri": "/device/batchUpgrade",
    "pageId": "15103",
    "page_uri": "POST /device/batchUpgrade",
    "title": "批量升级",
    "type": "POST"
  },
  "GETDeviceUpgradeDescribeList": {
    "uri": "/device/upgradeDescribeList",
    "pageId": "15105",
    "page_uri": "GET /device/upgradeDescribeList",
    "title": "获取升级描述列表",
    "type": "GET"
  },
  "GETDeviceHasLatestVersion": {
    "uri": "/device/hasLatestVersion",
    "pageId": "15108",
    "page_uri": "GET /device/hasLatestVersion",
    "title": "获取设备是否存在新版本",
    "type": "GET"
  },
  "POSTDeviceBatchConfigIni": {
    "uri": "/device/batchConfigIni",
    "pageId": "15983",
    "page_uri": "POST /device/batchConfigIni",
    "title": "批量配置ini",
    "type": "POST"
  },
  "GETDeviceUpgradeList": {
    "uri": "/device/upgradeList",
    "pageId": "15984",
    "page_uri": "GET /device/upgradeList",
    "title": "升级任务列表",
    "type": "GET"
  },
  "POSTDeviceUpgradeReset": {
    "uri": "/device/upgradeReset",
    "pageId": "15985",
    "page_uri": "POST /device/upgradeReset",
    "title": "升级任务重试",
    "type": "POST"
  },
  "GETDeviceVideoFlv": {
    "uri": "/device/videoFlv",
    "pageId": "12825",
    "page_uri": "GET /device/videoFlv",
    "title": "获取视频播放链接",
    "type": "GET"
  },
  "PUTDeviceVideoFlv": {
    "uri": "/device/videoFlv",
    "pageId": "12826",
    "page_uri": "PUT /device/videoFlv",
    "title": "停止播放",
    "type": "PUT"
  },
  "POSTDeviceVideoFlvHeart": {
    "uri": "/device/videoFlv/heart",
    "pageId": "12865",
    "page_uri": "POST /device/videoFlv/heart",
    "title": "视频播放心跳",
    "type": "POST"
  },
  "GETRtpPlayStatus": {
    "uri": "/rtp/playStatus",
    "pageId": "12905",
    "page_uri": "GET /rtp/playStatus",
    "title": "获取设备视频播放状态",
    "type": "GET"
  },
  "GETEmployee": {
    "uri": "/employee",
    "pageId": "12828",
    "page_uri": "GET /employee",
    "title": "用户列表",
    "type": "GET"
  },
  "POSTEmployee": {
    "uri": "/employee",
    "pageId": "12829",
    "page_uri": "POST /employee",
    "title": "新增用户",
    "type": "POST"
  },
  "PUTEmployee": {
    "uri": "/employee",
    "pageId": "12830",
    "page_uri": "PUT /employee",
    "title": "修改用户",
    "type": "PUT"
  },
  "DELETEEmployee": {
    "uri": "/employee",
    "pageId": "12831",
    "page_uri": "DELETE /employee",
    "title": "删除用户",
    "type": "DELETE"
  },
  "GETRoleList": {
    "uri": "/role/list",
    "pageId": "12848",
    "page_uri": "GET /role/list",
    "title": "角色列表",
    "type": "GET"
  },
  "POSTRoleAddRole": {
    "uri": "/role/addRole",
    "pageId": "13594",
    "page_uri": "POST /role/addRole",
    "title": "新增角色",
    "type": "POST"
  },
  "DELETERoleDeleteRole": {
    "uri": "/role/deleteRole",
    "pageId": "13596",
    "page_uri": "DELETE /role/deleteRole",
    "title": "删除角色",
    "type": "DELETE"
  },
  "POSTRoleUpdateRole": {
    "uri": "/role/updateRole",
    "pageId": "13597",
    "page_uri": "POST /role/updateRole",
    "title": "更新角色",
    "type": "POST"
  },
  "GETRoleRoleAuth": {
    "uri": "/role/roleAuth",
    "pageId": "13593",
    "page_uri": "GET /role/roleAuth",
    "title": "角色权限列表",
    "type": "GET"
  },
  "POSTRoleAuthEdit": {
    "uri": "/role/authEdit",
    "pageId": "13598",
    "page_uri": "POST /role/authEdit",
    "title": "权限编辑",
    "type": "POST"
  },
  "GETDictList": {
    "uri": "/dict/list",
    "pageId": "13591",
    "page_uri": "GET /dict/list",
    "title": "字典列表",
    "type": "GET"
  },
  "GETDictValueList": {
    "uri": "/dict/valueList",
    "pageId": "13592",
    "page_uri": "GET /dict/valueList",
    "title": "字典值列表",
    "type": "GET"
  },
  "POSTDictUpdate": {
    "uri": "/dict/update",
    "pageId": "13599",
    "page_uri": "POST /dict/update",
    "title": "编辑字典",
    "type": "POST"
  },
  "post/dict/updateDictValue": {
    "uri": "",
    "pageId": "13600",
    "page_uri": "post /dict/updateDictValue   ",
    "title": "编辑字典值",
    "type": "post/dict/updateDictValue"
  },
  "post/dict/addDictValue": {
    "uri": "",
    "pageId": "13601",
    "page_uri": "post /dict/addDictValue   ",
    "title": "新增字典值",
    "type": "post/dict/addDictValue"
  },
  "DELETE/dict/delDictValue": {
    "uri": "",
    "pageId": "13602",
    "page_uri": "DELETE /dict/delDictValue   ",
    "title": "删除字典值",
    "type": "DELETE/dict/delDictValue"
  },
  "GETOrganizationManageTree": {
    "uri": "/organizationManage/tree",
    "pageId": "13586",
    "page_uri": "GET /organizationManage/tree",
    "title": "查询组织树",
    "type": "GET"
  },
  "GETOrganizationManageList": {
    "uri": "/organizationManage/List",
    "pageId": "13587",
    "page_uri": "GET /organizationManage/List",
    "title": "查询组织列表",
    "type": "GET"
  },
  "POSTOrganizationManageAdd": {
    "uri": "/organizationManage/add",
    "pageId": "13588",
    "page_uri": "POST /organizationManage/add",
    "title": "新增机构",
    "type": "POST"
  },
  "POSTOrganizationManageUpdate": {
    "uri": "/organizationManage/update",
    "pageId": "13589",
    "page_uri": "POST /organizationManage/update",
    "title": "修改机构",
    "type": "POST"
  },
  "DELETEOrganizationManageDelete": {
    "uri": "/organizationManage/delete",
    "pageId": "13590",
    "page_uri": "DELETE /organizationManage/delete",
    "title": "删除机构",
    "type": "DELETE"
  },
  "GETOpen-resourceFile": {
    "uri": "/open-resource/file",
    "pageId": "16011",
    "page_uri": "GET /open-resource/file",
    "title": "对外资源包-列表",
    "type": "GET"
  },
  "POSTOpen-resourceFile": {
    "uri": "/open-resource/file",
    "pageId": "16016",
    "page_uri": "POST /open-resource/file",
    "title": "对外资源包-新增",
    "type": "POST"
  },
  "PUTOpen-resourceFile": {
    "uri": "/open-resource/file",
    "pageId": "16017",
    "page_uri": "PUT /open-resource/file",
    "title": "对外资源包-修改",
    "type": "PUT"
  },
  "DELETEOpen-resourceFile": {
    "uri": "/open-resource/file",
    "pageId": "16018",
    "page_uri": "DELETE /open-resource/file",
    "title": "对外资源包-删除",
    "type": "DELETE"
  },
  "POSTOpen-resourceMenu": {
    "uri": "/open-resource/menu",
    "pageId": "16012",
    "page_uri": "POST /open-resource/menu",
    "title": "对外资源包-新增菜单",
    "type": "POST"
  },
  "PUTOpen-resourceMenu": {
    "uri": "/open-resource/menu",
    "pageId": "16013",
    "page_uri": "PUT /open-resource/menu",
    "title": "对外资源包-修改菜单",
    "type": "PUT"
  },
  "DELETEOpen-resourceMenu": {
    "uri": "/open-resource/menu",
    "pageId": "16015",
    "page_uri": "DELETE /open-resource/menu",
    "title": "对外资源包-删除菜单",
    "type": "DELETE"
  },
  "GETOpen-resourceMenu": {
    "uri": "/open-resource/menu",
    "pageId": "16014",
    "page_uri": "GET /open-resource/menu",
    "title": "对外资源包-菜单树",
    "type": "GET"
  },
  "POSTResourceAddPackage": {
    "uri": "/resource/addPackage",
    "pageId": "15087",
    "page_uri": "POST /resource/addPackage",
    "title": "升级包-新增",
    "type": "POST"
  },
  "POSTResourceDeletePackage": {
    "uri": "/resource/deletePackage",
    "pageId": "15088",
    "page_uri": "POST /resource/deletePackage",
    "title": "升级包-删除",
    "type": "POST"
  },
  "GETResourcePackageList": {
    "uri": "/resource/packageList",
    "pageId": "15089",
    "page_uri": "GET /resource/packageList",
    "title": "升级包-列表",
    "type": "GET"
  },
  "POSTResourceEditPackage": {
    "uri": "/resource/editPackage",
    "pageId": "15104",
    "page_uri": "POST /resource/editPackage",
    "title": "升级包-修改",
    "type": "POST"
  },
  "GETResourceOssUploadCredentialUrl": {
    "uri": "/resource/ossUploadCredentialUrl",
    "pageId": "15106",
    "page_uri": "GET /resource/ossUploadCredentialUrl",
    "title": "获取OSS上传的路径",
    "type": "GET"
  },
  "GETBoardDistribute": {
    "uri": "/board/distribute",
    "pageId": "15173",
    "page_uri": "GET /board/distribute",
    "title": "全国各个省份统计数据(中间地图用)",
    "type": "GET"
  },
  "GETBoardCompany": {
    "uri": "/board/company",
    "pageId": "15775",
    "page_uri": "GET /board/company",
    "title": "查询企业",
    "type": "GET"
  },
  "GETBoardCompanyRegion": {
    "uri": "/board/company/region",
    "pageId": "15776",
    "page_uri": "GET /board/company/region",
    "title": "企业-区域列表",
    "type": "GET"
  },
  "GETBoardRegionDeviceList": {
    "uri": "/board/region/deviceList",
    "pageId": "15777",
    "page_uri": "GET /board/region/deviceList",
    "title": "区域-设备列表",
    "type": "GET"
  },
  "GETBoardBindMonthTrend": {
    "uri": "/board/bind/monthTrend",
    "pageId": "15778",
    "page_uri": "GET /board/bind/monthTrend",
    "title": "设备月增长趋势",
    "type": "GET"
  },
  "GETBoardDashboardStatistics": {
    "uri": "/board/dashboard/statistics",
    "pageId": "15779",
    "page_uri": "GET /board/dashboard/statistics",
    "title": "设备-企业相关数据统计",
    "type": "GET"
  },
  "GETBoardShipmentTop5": {
    "uri": "/board/shipment/top5",
    "pageId": "15780",
    "page_uri": "GET /board/shipment/top5",
    "title": "企业出货top5",
    "type": "GET"
  },
  "GETBoardRegionCityDevice": {
    "uri": "/board/region/cityDevice",
    "pageId": "15799",
    "page_uri": "GET /board/region/cityDevice",
    "title": "通过省份查询设备分布的城市",
    "type": "GET"
  },
  "GETBoardRegionCityCompanyDevice": {
    "uri": "/board/region/cityCompanyDevice",
    "pageId": "15800",
    "page_uri": "GET /board/region/cityCompanyDevice",
    "title": "查询企业",
    "type": "GET"
  },
  "GETBoardRegionCityCompanyDeviceGroup": {
    "uri": "/board/region/cityCompanyDeviceGroup",
    "pageId": "15801",
    "page_uri": "GET /board/region/cityCompanyDeviceGroup",
    "title": "通过省份查城市和企业",
    "type": "GET"
  },
  "GETBoardRegionCityCompanyDeviceList": {
    "uri": "/board/region/cityCompanyDeviceList",
    "pageId": "15807",
    "page_uri": "GET /board/region/cityCompanyDeviceList",
    "title": "具体省份-企业-设备列表",
    "type": "GET"
  },
  "GETAccUserConfig": {
    "uri": "/acc/userConfig",
    "pageId": "15815",
    "page_uri": "GET /acc/userConfig",
    "title": "看板配置",
    "type": "GET"
  },
  "POSTAccUserConfig": {
    "uri": "/acc/userConfig",
    "pageId": "15816",
    "page_uri": "POST /acc/userConfig",
    "title": "看板配置-修改",
    "type": "POST"
  },
  "GETStatisticsMonthQoq": {
    "uri": "/statistics/monthQoq",
    "pageId": "15787",
    "page_uri": "GET /statistics/monthQoq",
    "title": "蜂巢统计数据-月份",
    "type": "GET"
  },
  "GETStatisticsStatisticsNum": {
    "uri": "/statistics/statisticsNum",
    "pageId": "15788",
    "page_uri": "GET /statistics/statisticsNum",
    "title": "蜂巢统计数据-总数",
    "type": "GET"
  },
  "GETStatisticsWeekQoq": {
    "uri": "/statistics/weekQoq",
    "pageId": "15789",
    "page_uri": "GET /statistics/weekQoq",
    "title": "蜂巢统计数据-周",
    "type": "GET"
  },
  "GETStatisticsDayPlayRank": {
    "uri": "/statistics/dayPlayRank",
    "pageId": "15790",
    "page_uri": "GET /statistics/dayPlayRank",
    "title": "蜂巢统计数据-日播放请求排名",
    "type": "GET"
  },
  "GETSsoApiParkingReport": {
    "uri": "/sso/api/parkingReport",
    "pageId": "15791",
    "page_uri": "GET /sso/api/parkingReport",
    "title": "云停统计数据",
    "type": "GET"
  },
  "GETStatisticsSubCompany": {
    "uri": "/statistics/subCompany",
    "pageId": "15792",
    "page_uri": "GET /statistics/subCompany",
    "title": "蜂巢统计数据-公司搜索",
    "type": "GET"
  },
  "GETParkingsReport": {
    "uri": "/parkings/report",
    "pageId": "15793",
    "page_uri": "GET /parkings/report",
    "title": "货联统计数据",
    "type": "GET"
  }
}